// extracted by mini-css-extract-plugin
module.exports = {"header":"W9we0","logo":"m9lXd","quantitySelector":"OVIPg","quantitySelector-container":"UF7Gn","quantity-content":"tac5p","quantity-btn":"vYpSW"};